export const STEP_ONE = {
  flowName: 'Suscribir APV',
  back: 'Volver',
  title: 'Paso 1: Tu ahorro',
  subtitle: 'Indica el monto de ahorro. Podrás modificarlo cuando quieras',
  cardTitle: '¿Cuánto quieres ahorrar cada mes?',
  cardSubtitle:
    'Tu empleador descontará este monto por planilla',
  unitQuestion: '¿En qué unidad?',
  amountQuestion: '¿Cuánto deseas ahorrar?',
  amountPlaceholder: '0',
  notice:
    'Te informamos que, de acuerdo a lo establecido en el Código del Trabajo, los descuentos por planilla adicionales al 17% obligatorio (salud y previsión) tienen un máximo del 15% de tu remuneración bruta.',
  submitButton: 'Continuar',
  editTitle: 'Edita tu ahorro',
  editSubtitle: 'Indica el monto de ahorro. Podrás modificarlo cuando quieras',
  editBack: 'Volver a confirmar la suscripción',
  editSubmit: 'Guardar cambios',
};

export const CURRENCY_UNITS = [
  {
    id: 'pesos',
    label: 'Pesos $',
    prefix: '$',
    helpText: 'Mínimo $1.000.',
    errorText: 'Debe ser mínimo $1.000/máximo $999.999.999',
  },
  {
    id: 'uf',
    label: 'UF',
    prefix: 'UF',
    helpText: 'Mínimo 1 UF.',
    errorText: 'Debe ser mínimo 1 UF y máximo 50 UF',
  },
];
